export function toUniqueElements<T>(elements: T[]): T[] {
  return elements.filter(
    (element, index, self) => self.indexOf(element) === index,
  );
}
